export default __webpack_public_path__ + "static/media/fundoAzul.80e8b747.png";